import { FilterKeyConfig } from 'src/utils/filters/parseUrlFilters';

export const filterKeyMap: FilterKeyConfig[] = [
  // Strings
  { key: 'acids', type: 'string', isArray: true },
  { key: 'aircraftCategories', type: 'string', isArray: true },
  { key: 'aircraftTypes', type: 'string', isArray: true },
  { key: 'airlines', type: 'string', isArray: true },
  { key: 'infringementTypes', type: 'string', isArray: true },
  { key: 'operationTypes', type: 'string', isArray: true },
  { key: 'operatorCategories', type: 'string', isArray: true },
  { key: 'ruleNames', type: 'string', isArray: true },
  { key: 'severities', type: 'string', isArray: true },
  { key: 'statuses', type: 'string', isArray: true },
  // Numbers
  { key: 'ruleIds', type: 'number', isArray: true },
  { key: 'limitToIds', type: 'number', isArray: true },
  // Dates
  { key: 'timePeriod', type: 'timeRange', isArray: false },
];

export const INFRINGEMENTS_QUERY_FIRST = 1000; // Default first value for infringements queries
